import * as React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import heroStyles from "../Styling/HeroAreaStyling";

interface IHeroArea {
    imageUri: string;
    title: string;
    subtitle: string;
}

const LargeHeroArea: React.FC<IHeroArea> = ({
    imageUri,
    title,
    subtitle,
    children
}) => {
    const classes = heroStyles(imageUri)();

    return (
        <section
            className={classes.heroContent + " " + classes.largeHeroContent}
        >
            <div className={classes.blackOverlay}></div>
            <Container className={classes.wrapper}>
                <Grid
                    className={classes.heroBox}
                    justify="flex-start"
                    alignItems="center"
                    container
                    spacing={3}
                >
                    <Grid item xl={6} lg={6} md={6} sm={10} xs={12}>
                        <Typography
                            variant="h1"
                            gutterBottom
                            className={classes.titleLarge}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            paragraph
                            className={classes.textLarge}
                        >
                            {subtitle}
                        </Typography>
                        <div className={classes.button}>{children}</div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default LargeHeroArea;
